import { createSlice } from '@reduxjs/toolkit';
import { IClause } from '../Features/Drafting/Interfaces';

interface DraftingState {
    redraftingClause: IClause | null;
}

const initialState: DraftingState = {
  redraftingClause: null,
};

export const selectRedraftingClause = (state: any) => state.drafting.redraftingClause;

export const draftingSlice = createSlice({
  name: 'drafting',
  initialState,
  reducers: {
    setRedraftingClause: (state, action) => {
        state.redraftingClause = action.payload;
    },
  }
});

export default draftingSlice.reducer;